export const parseNumberFieldValue = (value: string): number | null => {
  const num = parseInt(value, 10);

  return isNaN(num) ? null : num;
};

export const parseMultiNumberFieldValue = (values: string[]): (number | null)[] => (
  values.map(parseNumberFieldValue)
);
